import { Controller } from "@hotwired/stimulus";
import Tribute from "tributejs";

export default class extends Controller {
  static targets = ["input"];
  static values = { users: Array };

  connect() {
    this.tribute = new Tribute({
      values: this.usersValue,
      selectClass: 'tribute-highlight',
      // allowSpaces: true,
      // requireLeadingSpace: true,
      selectTemplate: function (item) {
        // Convert display name to Capital Case
        const displayName = item?.original?.display_name || '';
        const capitalCased = displayName
          .split(/\s+/) // Split by spaces
          .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1); // Only capitalize first letter
          })
          .join(''); // Join with spaces
        
        return `@${capitalCased}`;
      },
      lookup: function (user, mentionText) {
        // Convert display name to Capital Case for the lookup display
        const displayName = user?.display_name || '';
        const capitalCasedDisplayName = displayName
          .split(/\s+/)
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Only capitalize first letter
          .join('');
        return capitalCasedDisplayName + ' &lt;' + user.email + '&gt;';
      },
      noMatchTemplate: function () {
        return '<span style:"visibility: hidden;"></span>';
      },
    })
      this.inputTarget.addEventListener("tribute-active-false", function(e) {
        console.log("Menu closed!");
      })
      this.inputTarget.addEventListener("tribute-replaced", function(e) {
        console.log(
          "Original event that triggered text replacement:",
          e.detail.event
        );
        console.log("Matched item:", e.detail.item);
      });
    this.tribute.attach(this.inputTarget);
  }

  disconnect() {
    if (this.tribute) {
      this.tribute.detach(this.inputTarget);
      this.tribute = null;
    }
  }

  // You could have a method to update the user list dynamically
  updateUsers(newUsers) {
    if (this.tribute) {
      this.tribute.update(newUsers);
    }
  }
}
